import { getCookie, setCookie } from './cookies';

const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';

export const setNextLocaleCookie = (language?: string | null): void => {
	if (!language) {
		return;
	}

	if (getCookie(LOCALE_COOKIE_NAME) === language) {
		return;
	}

	setCookie(LOCALE_COOKIE_NAME, language, { expires: 1, path: '/' });
};
